module.exports = __webpack_public_path__ + "img/a1.409e2b14.png";